import * as React from 'react';
import * as Utilities from '../../../../../_common/platform/ts/Utilities';

export function NavBarPreview(glob, _theme) {
    let activeTabStyle: React.CSSProperties = {
        paddingLeft: '0.25rem'
    };

    if (_theme['navbar-material-style'] !== true) {
        if (_theme['workspace-bg'] != null) {
            activeTabStyle.backgroundColor = _theme['workspace-bg'];
            activeTabStyle.color = Utilities.getContrastColor(activeTabStyle.backgroundColor);
        } else if (_theme['body-bg'] != null) {
            activeTabStyle.backgroundColor = _theme['body-bg'];
            activeTabStyle.color = Utilities.getContrastColor(activeTabStyle.backgroundColor);
        } else {
            activeTabStyle.backgroundColor = '#FFFFFF';
            activeTabStyle.color = '#000000';
        }
        activeTabStyle.borderBottom = 'none';
    }

    return [
        <div
            className={'navbar navbar-expand-lg navbar-color-pattern'}
            style={{ height: '3rem', paddingBottom: '0px' }}
        >
            <div className="collapse navbar-collapse workspace-tabs-scrollable ">
                <form className="form-inline">
                    <div className="btn border-0">
                        <span className="glyphicon glyphicon-align-justify"></span>
                        <span className="caret"></span>
                    </div>
                </form>
                <ul className="nav nav-tabs border-0" key="nav-tab-preview">
                    <li className="nav-item">
                        <div className="nav-link d-flex flex-row justify-content-start active" style={activeTabStyle}>
                            <span className="glyphicon glyphicon-remove"></span>
                            <span style={activeTabStyle}>Administration</span>
                        </div>
                    </li>
                    <li className="nav-item">
                        <div className="nav-link d-flex flex-row justify-content-start">
                            <span className="glyphicon glyphicon-remove"></span>
                            <span style={{ paddingLeft: '0.25rem' }}>Workspace</span>
                        </div>
                    </li>
                    <li className="nav-item">
                        <div className="nav-link d-flex flex-row justify-content-start">
                            <span className="glyphicon glyphicon-remove"></span>
                            <span style={{ paddingLeft: '0.25rem' }}>Demo</span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    ];
}
